module.exports = __webpack_public_path__ + "img/yiyangchafu-icon.6059c554.png";